// All mock/static content for AdalCrea premium site.
// Bilingual fields use { tr, en } objects.

export const IMAGES = {
  heroDashboard:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGludGVsbGlnZW5jZSUyMGRhc2hib2FyZHxlbnwwfHx8fDE3OTAxNjY3OTJ8MA&ixlib=rb-4.1.0&q=85",
  dataCenter:
    "https://images.pexels.com/photos/17489163/pexels-photo-17489163.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  dataCenter2:
    "https://images.unsplash.com/flagged/photo-1579274216947-86eaa4b00475?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxkYXRhJTIwY2VudGVyfGVufDB8fHx8MTc5MDE2NjgwM3ww&ixlib=rb-4.1.0&q=85",
  serverRack:
    "https://images.unsplash.com/photo-1506399558188-acca6f8cbf41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxkYXRhJTIwY2VudGVyfGVufDB8fHx8MTc5MDE2NjgwM3ww&ixlib=rb-4.1.0&q=85",
  cyber1:
    "https://images.unsplash.com/photo-1639322537228-f710d846310a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5JTIwbmV0d29ya3xlbnwwfHx8fDE3OTAxNjY3OTJ8MA&ixlib=rb-4.1.0&q=85",
  cyber2:
    "https://images.unsplash.com/photo-1751448555253-f39c06e29d82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxjeWJlcnNlY3VyaXR5JTIwbmV0d29ya3xlbnwwfHx8fDE3OTAxNjY3OTJ8MA&ixlib=rb-4.1.0&q=85",
  cyber3:
    "https://images.unsplash.com/photo-1691435828932-911a7801adfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxjeWJlcnNlY3VyaXR5JTIwbmV0d29ya3xlbnwwfHx8fDE3OTAxNjY3OTJ8MA&ixlib=rb-4.1.0&q=85",
  bi1:
    "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGludGVsbGlnZW5jZSUyMGRhc2hib2FyZHxlbnwwfHx8fDE3OTAxNjY3OTJ8MA&ixlib=rb-4.1.0&q=85",
  cloud1:
    "https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxjbG91ZCUyMGNvbXB1dGluZ3xlbnwwfHx8fDE3OTAxNjY4NDR8MA&ixlib=rb-4.1.0&q=85",
  cloud2:
    "https://images.unsplash.com/photo-1690627931320-16ac56eb2588?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxjbG91ZCUyMGNvbXB1dGluZ3xlbnwwfHx8fDE3OTAxNjY4NDR8MA&ixlib=rb-4.1.0&q=85",
  cloud3:
    "https://images.pexels.com/photos/1181354/pexels-photo-1181354.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  team1:
    "/assets/adalcrea-digital-transformation-kit.webp",
  team2:
    "https://images.unsplash.com/photo-1779278617831-b47198f3c3b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHx0ZWNoJTIwb2ZmaWNlJTIwdGVhbXxlbnwwfHx8fDE3OTAxNjY4NDR8MA&ixlib=rb-4.1.0&q=85",
  workplace1:
    "https://images.unsplash.com/photo-1787647562131-1946de332c38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwd29ya3BsYWNlfGVufDB8fHx8MTc5MDE2Njg0NHww&ixlib=rb-4.1.0&q=85",
  workplace2:
    "https://images.unsplash.com/photo-1787647560683-0e4b037ea9d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwd29ya3BsYWNlfGVufDB8fHx8MTc5MDE2Njg0NHww&ixlib=rb-4.1.0&q=85",
};

// Partner technology logos (Simple Icons CDN, with graceful text fallback)
export const PARTNERS = [
  { name: "Microsoft", slug: "microsoft", size: "h-9" },
  { name: "Fortinet", slug: "fortinet", size: "h-9" },
  { name: "Dell", slug: "dell", size: "h-10" },
  { name: "Synology", slug: "synology", size: "h-14" },
  { name: "Microsoft Azure", slug: "microsoftazure", size: "h-9" },
  { name: "Amazon AWS", slug: "amazonaws", size: "h-9" },
];

// Four strategic service verticals
export const SERVICES = [
  {
    id: "strategic-consulting",
    slug: "stratejik-donusum-danismanlik",
    icon: "Landmark",
    number: "01",
    image: IMAGES.serverRack,
    tag: { tr: "Stratejik Danışmanlık", en: "Strategic Consulting" },
    title: { tr: "Stratejik Dönüşüm & Danışmanlık", en: "Strategic Transformation & Consulting" },
    short: {
      tr: "IT altyapınızın röntgeninden Microsoft 365 lisans optimizasyonuna, BPM süreç dijitalleşmesinden kurumsal donanım teminine kadar uçtan uca strateji.",
      en: "End-to-end strategy from an X-ray of your IT infrastructure to Microsoft 365 license optimization, BPM process digitalization and enterprise hardware procurement.",
    },
    features: {
      tr: [
        "BT Olgunluk Analizi",
        "BPM & Onboarding/Offboarding Dijitalleşmesi",
        "Kurumsal Donanım Tedariği",
        "Otomasyon & Yapay Zekâ Dönüşümü",
        "Siber Güvenlik ve Veri Yönetimi",
        "Microsoft 365 Lisans Optimizasyonu",
      ],
      en: [
        "IT Maturity Assessment",
        "BPM & Onboarding/Offboarding Digitalization",
        "Enterprise Hardware Procurement",
        "Automation & AI Transformation",
        "Cyber Security and Data Management",
        "Microsoft 365 License Optimization",
      ],
    },
  },
  {
    id: "cyber-security",
    slug: "siber-guvenlik-esnek-calisma",
    icon: "ShieldCheck",
    number: "02",
    image: IMAGES.cyber1,
    tag: { tr: "Siber Güvenlik", en: "Cyber Security" },
    title: { tr: "Siber Güvenlik & Esnek Çalışma", en: "Cyber Security & Flexible Work" },
    short: {
      tr: "FortiGate güvenli altyapısından Intune – Jamf – ManageEngine ile MDM/MAM yönetimine, VPN uzaktan çalışmadan felaket kurtarma planlarına kadar tam koruma.",
      en: "Full protection from FortiGate secure infrastructure to MDM/MAM management with Intune – Jamf – ManageEngine, VPN remote work and disaster recovery plans.",
    },
    features: {
      tr: [
        "Felaket Kurtarma & İş Sürekliliği",
        "FortiGate Merkez-Şube & Zero-Trust Mimarisi",
        "Yönetilen Güvenlik Duvarı Hizmetleri",
        "Merkezi Veri Depolama & Yedekleme",
        "Cihaz & Politika Yönetimi (MDM/MAM)",
        "Güvenli Esnek Çalışma & İş Sürekliliği",
      ],
      en: [
        "Disaster Recovery & Business Continuity",
        "FortiGate HQ-Branch & Zero-Trust Architecture",
        "Managed Firewall Services",
        "Centralized Data Storage & Backup",
        "Device & Policy Management (MDM/MAM)",
        "Secure Flexible Work & Business Continuity",
      ],
    },
  },
  {
    id: "business-intelligence",
    slug: "is-zekasi-veri-yonetimi",
    icon: "BarChart3",
    number: "03",
    image: IMAGES.bi1,
    tag: { tr: "İş Zekası & Veri", en: "BI & Data" },
    title: { tr: "İş Zekası & Veri Yönetimi", en: "Business Intelligence & Data Management" },
    short: {
      tr: "İK entegre Power BI envanter dashboard'larından Power Platform low-code çözümlerine, Synology NAS'tan Teams kurumsal hafızaya kadar.",
      en: "From HR-integrated Power BI inventory dashboards to Power Platform low-code solutions, Synology NAS and Teams enterprise memory.",
    },
    features: {
      tr: [
        "Power BI İleri Düzey Analitik Paneli",
        "Low-Code ile Hızlı Uygulama Geliştirme",
        "Dijital İş Birliği & Bilgi Yönetimi",
        "Synology Kurumsal NAS",
        "İK Entegre Canlı Envanter Takibi",
        "Teams Kurumsal Hafıza & Arşiv",
      ],
      en: [
        "Advanced Power BI Analytics Panel",
        "Rapid App Development with Low-Code",
        "Digital Collaboration & Knowledge Management",
        "Synology Enterprise NAS",
        "HR-Integrated Live Inventory Tracking",
        "Teams Enterprise Memory & Archive",
      ],
    },
  },
  {
    id: "cloud-green-it",
    slug: "bulut-altyapi-yesil-it",
    icon: "Leaf",
    number: "04",
    image: IMAGES.cloud1,
    tag: { tr: "Bulut & ESG", en: "Cloud & ESG" },
    title: { tr: "Bulut Altyapı & Yeşil IT (ESG)", en: "Cloud Infrastructure & Green IT (ESG)" },
    short: {
      tr: "Universal Print ile çok lokasyonlu maliyet tasarrufu, e-imza ile sıfır kağıt, Azure/AWS bulut migrasyonu ile sürdürülebilir ve modern altyapı.",
      en: "Multi-location cost savings with Universal Print, paperless with e-signature, sustainable and modern infrastructure with Azure/AWS cloud migration.",
    },
    features: {
      tr: [
        "Universal Print — Çok Lokasyonlu Bulut Yazdırma",
        "E-İmza & Sıfır Kağıt Platformları (ESG Uyum)",
        "Çoklu Bulut Migrasyonu & Yönetimi",
        "Bulut FinOps & Maliyet Kontrolü",
        "Azure / AWS Modern Altyapı",
        "Sürdürülebilir Yeşil IT Danışmanlığı",
      ],
      en: [
        "Universal Print — Multi-Location Cloud Printing",
        "E-Signature & Paperless Platforms (ESG Compliance)",
        "Multi-Cloud Migration & Management",
        "Cloud FinOps & Cost Control",
        "Azure / AWS Modern Infrastructure",
        "Sustainable Green IT Consulting",
      ],
    },
  },
];

// The service dropdown options for the contact form
export const SERVICE_OPTIONS = SERVICES.map((s) => ({ value: s.id, label: s.title }));

// About page stats
export const ABOUT_STATS = [
  { value: "7/24", label: { tr: "Proaktif İzleme", en: "Proactive Monitoring" } },
  { value: "%40", label: { tr: "Ort. Maliyet Tasarrufu", en: "Avg. Cost Savings" } },
  { value: "4", label: { tr: "Stratejik Dikey", en: "Strategic Verticals" } },
  { value: "0₺", label: { tr: "İlk Analiz Ücreti", en: "First Analysis Fee" } },
];

// Blog posts
export const BLOG_CATEGORIES = [
  { id: "all", label: { tr: "Tümü", en: "All" } },
  { id: "cloud", label: { tr: "Bulut & ESG", en: "Cloud & ESG" } },
  { id: "security", label: { tr: "Siber Güvenlik", en: "Cyber Security" } },
  { id: "data", label: { tr: "İş Zekası", en: "Business Intelligence" } },
  { id: "strategy", label: { tr: "Strateji", en: "Strategy" } },
];

export const BLOG_POSTS = [
  {
    id: "universal-print-maliyet",
    slug: "universal-print-ile-yazici-maliyetlerini-dusurmek",
    category: "cloud",
    image: IMAGES.cloud2,
    date: "2026-06-12",
    readTime: 6,
    author: "AdalCrea",
    title: {
      tr: "Universal Print ile Yazıcı Maliyetlerini %50 Nasıl Düşürürsünüz?",
      en: "How to Cut Printing Costs by 50% with Universal Print",
    },
    excerpt: {
      tr: "Çok lokasyonlu şirketlerde kontrolden çıkan yazıcı bütçeleri, bulut tabanlı yazdırma ile nasıl yönetilebilir? Universal Print mimarisini ve gerçek tasarruf senaryolarını inceliyoruz.",
      en: "How can runaway printing budgets in multi-location companies be managed with cloud-based printing? We examine the Universal Print architecture and real savings scenarios.",
    },
    content: {
      tr: [
        "Onlarca ofis ve yüzlerce yazıcıya sahip kurumlarda, baskı maliyetleri çoğu zaman görünmez bir gider kalemine dönüşür. Her lokasyonda ayrı yazıcı sürücüleri, ayrı yönetim ve kimin ne kadar bastığına dair belirsizlik hem bütçeyi hem de sürdürülebilirlik hedeflerini zorlar.",
        "Microsoft Universal Print, tüm yazdırma altyapınızı buluta taşıyarak bu karmaşayı ortadan kaldırır. Tek bir sürücü ile şubeler arasında geçiş yaparken yeniden kurulum gerekmez; kullanıcılar bulundukları lokasyondaki en yakın yazıcıdan çıktı alabilir.",
        "Departman ve kullanıcı bazlı raporlama sayesinde, baskı hacmini şeffaf biçimde ölçebilir, gereksiz renkli çıktıları politika ile sınırlandırabilir ve ESG hedefleriniz doğrultusunda kağıt tüketimini düşürebilirsiniz.",
        "AdalCrea olarak, önce mevcut yazıcı envanterinizin röntgenini çekiyor, ardından Universal Print geçiş planınızı hazırlıyoruz. Tipik projelerde ilk aydan itibaren %35–50 aralığında maliyet düşüşü gözlemleniyor.",
      ],
      en: [
        "In organizations with dozens of offices and hundreds of printers, printing costs often become an invisible expense. Separate printer drivers, separate management and uncertainty about who prints how much strain both the budget and sustainability goals.",
        "Microsoft Universal Print eliminates this complexity by moving your entire printing infrastructure to the cloud. No reinstallation is needed when switching between branches with a single driver; users can print from the nearest printer at their location.",
        "With department- and user-based reporting, you can transparently measure print volume, limit unnecessary color prints with policies and reduce paper consumption in line with your ESG goals.",
        "At AdalCrea, we first X-ray your current printer inventory, then prepare your Universal Print migration plan. Typical projects observe a 35–50% cost reduction from the first month.",
      ],
    },
  },
  {
    id: "zero-trust-mimari",
    slug: "zero-trust-mimari-neden-kritik",
    category: "security",
    image: IMAGES.cyber2,
    date: "2026-05-28",
    readTime: 7,
    author: "AdalCrea",
    title: {
      tr: "Zero-Trust Mimari: Neden Artık Kaçınılmaz?",
      en: "Zero-Trust Architecture: Why It's No Longer Optional",
    },
    excerpt: {
      tr: "Uzaktan çalışma ve çok şubeli yapılar arttıkça geleneksel çevre güvenliği yetersiz kalıyor. FortiGate tabanlı Zero-Trust yaklaşımının temellerini açıklıyoruz.",
      en: "As remote work and multi-branch structures grow, traditional perimeter security falls short. We explain the fundamentals of a FortiGate-based Zero-Trust approach.",
    },
    content: {
      tr: [
        "\"Ağın içindekine güven, dışındakine güvenme\" varsayımı artık geçerli değil. Kimlik hırsızlığı ve iç tehditler, çevre güvenliğini tek başına yetersiz bırakıyor.",
        "Zero-Trust yaklaşımında hiçbir kullanıcı veya cihaz varsayılan olarak güvenilir kabul edilmez. Her erişim talebi kimlik, cihaz durumu ve bağlam üzerinden yeniden doğrulanır.",
        "FortiGate merkez-şube mimarisi ile bu prensipleri pratikte hayata geçiriyor; MDM/MAM çözümleriyle cihaz uyumluluğunu sürekli denetliyoruz.",
        "Sonuç: güvenli esnek çalışma, azalan saldırı yüzeyi ve iş sürekliliği. Röntgen aşamasında mevcut açıklarınızı tespit ediyor, önceliklendirilmiş bir yol haritası sunuyoruz.",
      ],
      en: [
        "The assumption of \"trust the inside of the network, distrust the outside\" is no longer valid. Credential theft and insider threats make perimeter security insufficient on its own.",
        "In the Zero-Trust approach, no user or device is trusted by default. Every access request is re-verified based on identity, device posture and context.",
        "We implement these principles in practice with FortiGate HQ-branch architecture and continuously audit device compliance with MDM/MAM solutions.",
        "The result: secure flexible work, a reduced attack surface and business continuity. In the X-ray phase we identify your current gaps and provide a prioritized roadmap.",
      ],
    },
  },
  {
    id: "power-bi-envanter",
    slug: "power-bi-ile-canli-envanter-yonetimi",
    category: "data",
    image: IMAGES.bi1,
    date: "2026-05-15",
    readTime: 5,
    author: "AdalCrea",
    title: {
      tr: "Power BI ile Canlı Envanter ve İK Entegrasyonu",
      en: "Live Inventory and HR Integration with Power BI",
    },
    excerpt: {
      tr: "\"Hangi cihaz kimdeydi, hangi lisans boşta?\" sorularına son. İK ile entegre Power BI panellerinin şirketinize kazandırdıklarını anlatıyoruz.",
      en: "End \"which device did who have, which license is idle?\" questions. We explain what HR-integrated Power BI dashboards bring to your company.",
    },
    content: {
      tr: [
        "Kurumsal cihaz ve lisans envanteri, çoğu şirkette dağınık Excel dosyalarında yönetilir. Bu da hem maliyet israfına hem de güvenlik riskine yol açar.",
        "Power Platform ile şirketinize özel, canlı bir envanter takip sistemi kuruyoruz. İK sisteminizle entegrasyon sayesinde personel giriş/çıkış süreçleri tamamen dijitalleşir.",
        "Bir çalışan işten ayrıldığında, ona zimmetli tüm cihaz ve lisanslar otomatik olarak iade sürecine girer. Boşa çıkan lisanslar anında görünür hale gelir.",
        "Power BI panelleri, yönetime tek ekranda net bir görünüm sunar: hangi cihaz nerede, hangi lisans kullanılmıyor, bütçe nereye gidiyor.",
      ],
      en: [
        "Enterprise device and license inventory is managed in scattered Excel files in most companies. This leads to both cost waste and security risk.",
        "With Power Platform, we build a custom, live inventory tracking system for your company. Thanks to integration with your HR system, staff onboarding/offboarding processes are fully digitalized.",
        "When an employee leaves, all devices and licenses assigned to them automatically enter the return process. Freed-up licenses become instantly visible.",
        "Power BI dashboards give management a clear view on a single screen: which device is where, which license is unused, where the budget goes.",
      ],
    },
  },
  {
    id: "m365-lisans-optimizasyonu",
    slug: "microsoft-365-lisans-optimizasyonu",
    category: "strategy",
    image: IMAGES.workplace1,
    date: "2026-04-30",
    readTime: 6,
    author: "AdalCrea",
    title: {
      tr: "Microsoft 365 Lisanslarınızda Gizli Maliyetler",
      en: "Hidden Costs in Your Microsoft 365 Licenses",
    },
    excerpt: {
      tr: "Çoğu kurum ihtiyacından fazla lisans için ödeme yapıyor. Doğru lisans analizinin bütçenize etkisini ve optimizasyon adımlarını inceliyoruz.",
      en: "Most organizations pay for more licenses than they need. We examine the impact of proper license analysis on your budget and the optimization steps.",
    },
    content: {
      tr: [
        "Microsoft 365, doğru kurgulandığında güçlü bir üretkenlik platformudur. Ancak zamanla biriken atıl lisanslar, kullanılmayan paketler ve yanlış atamalar ciddi bir bütçe kalemine dönüşür.",
        "Lisans analizinde önce kullanım verilerini inceliyoruz: kim hangi uygulamayı gerçekten kullanıyor, hangi lisanslar boşta duruyor, hangi kullanıcı yanlış plandaki.",
        "Ardından ihtiyaç bazlı bir lisans haritası çıkarıyor, gereksiz paketleri düşürüyor ve mümkün olduğunda daha uygun planlara geçiş öneriyoruz.",
        "Tipik projelerde, kullanılmayan lisansların temizlenmesi ile ciddi tasarruf sağlanırken, kullanıcı deneyimi hiç bozulmadan korunuyor.",
      ],
      en: [
        "Microsoft 365 is a powerful productivity platform when configured correctly. However, idle licenses that accumulate over time, unused packages and incorrect assignments turn into a significant budget item.",
        "In license analysis, we first examine usage data: who actually uses which app, which licenses are idle, which user is on the wrong plan.",
        "We then create a needs-based license map, drop unnecessary packages and, where possible, recommend migrating to more suitable plans.",
        "In typical projects, cleaning up unused licenses delivers significant savings while user experience is preserved without any disruption.",
      ],
    },
  },
  {
    id: "synology-nas-veri",
    slug: "synology-nas-ile-guvenli-veri-yonetimi",
    category: "data",
    image: IMAGES.dataCenter2,
    date: "2026-04-18",
    readTime: 5,
    author: "AdalCrea",
    title: {
      tr: "Synology NAS ile Bulut Bağımlılığını Azaltmak",
      en: "Reducing Cloud Dependency with Synology NAS",
    },
    excerpt: {
      tr: "Her veri bulutta olmak zorunda değil. Lokal, güvenli ve maliyet-etkin bir dosya sunucusunun hangi senaryolarda mantıklı olduğunu ele alıyoruz.",
      en: "Not every piece of data has to be in the cloud. We discuss in which scenarios a local, secure and cost-effective file server makes sense.",
    },
    content: {
      tr: [
        "Bulut depolama esneklik sağlar, ancak büyük veri hacimlerinde aylık maliyetler hızla artabilir. Ayrıca bazı sektörlerde verinin lokalde tutulması yasal bir gerekliliktir.",
        "Synology NAS, güvenli ve merkezi bir dosya sunucusu kurgulayarak bu ihtiyaçları karşılar. Otomatik yedekleme, sürüm kontrolü ve granüler erişim yönetimi sunar.",
        "Hibrit yaklaşımla, sık erişilen veriyi lokalde tutarken arşiv verisini buluta taşıyabilir, hem performans hem maliyet dengesini kurabilirsiniz.",
        "AdalCrea, veri sınıflandırmanızı yaparak hangi verinin nerede durması gerektiğine dair net bir mimari öneriyor.",
      ],
      en: [
        "Cloud storage provides flexibility, but monthly costs can rise quickly at large data volumes. Moreover, in some industries keeping data on-premises is a legal requirement.",
        "Synology NAS meets these needs by setting up a secure, centralized file server. It offers automatic backup, version control and granular access management.",
        "With a hybrid approach, you can keep frequently accessed data local while moving archive data to the cloud, balancing both performance and cost.",
        "AdalCrea classifies your data and recommends a clear architecture for where each type of data should reside.",
      ],
    },
  },
  {
    id: "esg-yesil-it",
    slug: "esg-uyumu-ve-yesil-it",
    category: "cloud",
    image: IMAGES.cloud3,
    date: "2026-04-02",
    readTime: 6,
    author: "AdalCrea",
    title: {
      tr: "ESG Uyumu: IT'nin Sürdürülebilirlikteki Rolü",
      en: "ESG Compliance: IT's Role in Sustainability",
    },
    excerpt: {
      tr: "Sıfır kağıt, e-imza ve enerji-verimli altyapı ile IT departmanı ESG hedeflerinin merkezine nasıl yerleşir? Somut adımları paylaşıyoruz.",
      en: "How does the IT department become central to ESG goals with paperless, e-signature and energy-efficient infrastructure? We share concrete steps.",
    },
    content: {
      tr: [
        "ESG (Çevresel, Sosyal, Yönetişim) artık sadece bir uyum konusu değil; müşteri ve yatırımcı beklentilerinin merkezinde. IT departmanı bu dönüşümde kritik bir rol oynuyor.",
        "E-imza ve sıfır kağıt platformları, hem operasyonel hızı artırır hem de kağıt tüketimini neredeyse sıfıra indirir. Aynı zamanda tam mevzuat uyumluluğu sağlar.",
        "Bulut migrasyonu ve FinOps ile enerji tüketimini optimize ediyor, atıl kaynakları kapatarak karbon ayak izini azaltıyoruz.",
        "Universal Print ve akıllı baskı politikaları, ölçülebilir çevresel kazanımlar sağlar. Tüm bu adımlar raporlanabilir ve denetlenebilir metriklerle desteklenir.",
      ],
      en: [
        "ESG (Environmental, Social, Governance) is no longer just a compliance topic; it is central to customer and investor expectations. The IT department plays a critical role in this transformation.",
        "E-signature and paperless platforms both increase operational speed and reduce paper consumption to almost zero. They also ensure full regulatory compliance.",
        "With cloud migration and FinOps, we optimize energy consumption and reduce the carbon footprint by shutting down idle resources.",
        "Universal Print and smart printing policies deliver measurable environmental gains. All these steps are supported by reportable and auditable metrics.",
      ],
    },
  },
];
